
export function getRemainingTime(milisecondApproved: number, amountTime: number): number {
  return (milisecondApproved + amountTime) - (new Date(new Date().toUTCString()).getTime());
}
